import { styled } from "styled-components";
import { transition } from "../../styles/mixins";
import Flow from "../common/Flow";
import Typography from "../common/Typography";
import WaypointType from "./WaypointType";

const Waypoint = styled.div`
  ${transition('background-color')}
  align-items: center;
  background-color: ${props => props.$active  ? 'var(--color-theme-secondary-500)' : 'inherit'};
  border: var(--border);
  display: flex;
  gap: var(--space-3);
  padding: var(--space-3);
  box-sizing: content-box;

  &:hover {
    background-color: var(--color-theme-primary-500);
  }
`;

const WaypointTypeImage = styled.div`
  align-items: center;
  border-right: var(--border);
  display: flex;
  justify-content: center;
  padding: var(--space-2);

  > div {
    width: var(--space-10);
  }
`;

function WaypointList({ waypoints }) {
  return (
    <Flow $space={3}>
      {waypoints && waypoints.map((waypoint, idx) => (
        <Waypoint key={idx}>
          <WaypointTypeImage>
            <WaypointType symbol={waypoint.symbol} type={waypoint.type} />
          </WaypointTypeImage>
          <div>
            <Typography as="h2" fontSize="md">{waypoint.symbol}</Typography>
          </div>
        </Waypoint>
      ))}
    </Flow>
  )
}

export default WaypointList;